import _ from 'lodash';
import storage from '@/scripts/tools/storage';
import { AES } from '@/scripts/tools/utils';
import { CONSTANT } from '@/scripts/tools/config';

const lastOauthKey = 'lastOauth';

export default {
  // 永久密钥登录密钥保存
  saveSecretKey(SecretId, SecretKey) {
    AES.encrypt(SecretKey, CONSTANT.encodeKey)
      .then(encodeText => {
        if (encodeText) {
          storage.add(SecretId, encodeText, 'session');
        }
      })
      .catch(err => {
        console.log('[saveSecretKey] error', JSON.stringify(err));
      });
  },
  // 永久密钥登录密钥获取
  getSecretKey(SecretId) {
    if (!storage.get(SecretId, 'session')) return '';

    const encodeText = storage.get(SecretId, 'session');
    return AES.decrypt(encodeText, CONSTANT.encodeKey);
  },
  // 永久密钥登录密钥删除
  deleteSecretKey(SecretId) {
    storage.del(SecretId, 'session');
  },
  // 腾讯云账号登录信息保存
  saveOauthInfo({ clientId, clientToken, userOpenId }) {
    const oauthInfo = { clientId, clientToken, userOpenId };
    const lastOauth = storage.get(lastOauthKey, 'session');
    // 比较本地，若无变化则不做变更
    if (!_.isEqual(oauthInfo, lastOauth)) {
      AES.encrypt(JSON.stringify(oauthInfo), CONSTANT.encodeKey)
        .then(encodeText => {
          if (encodeText) {
            storage.add(lastOauthKey, encodeText, 'session');
          }
        })
        .catch(err => {
          console.log('[saveOauthInfo] error', JSON.stringify(err));
        });
    }
  },
  // 腾讯云账号登录信息获取
  getOauthInfo() {
    if (!storage.get(lastOauthKey, 'session')) return '';

    const oauthInfo = storage.get(lastOauthKey, 'session');
    return AES.decrypt(oauthInfo, CONSTANT.encodeKey).then(text => {
      let info = text;
      try {
        info = JSON.parse(text);
      } catch (error) {
        //
      }
      return info;
    });
  },
  // 腾讯云账号登录信息删除
  deleteOauthInfo() {
    storage.del(lastOauthKey, 'session');
  },
  saveInfoByEncrypt(key, info, saveType) {
    storage.add(key, info, saveType);
    // const saveText = JSON.stringify(info);
    // AES.encrypt(saveText, CONSTANT.encodeKey)
    //   .then(encodeText => {
    //     if (encodeText) {
    //       storage.add(key, encodeText, saveType);
    //     }
    //   })
    //   .catch(err => {
    //     console.log('[saveSecretKey] error', JSON.stringify(err));
    //   });
  },
  getInfoByDecrypt(key) {
    let saveText = storage.get(key, 'local');
    if (!saveText) {
      saveText = storage.get(key, 'session');
    }
    return saveText;
    // return AES.decrypt(saveText, CONSTANT.encodeKey).then(text => {
    //   let info = text;
    //   try {
    //     info = JSON.parse(text);
    //   } catch (error) {
    //     //
    //   }
    //   return info;
    // });
  },
  clearInfo(key) {
    storage.del(key);
    storage.del(key, 'session');
  },

};
